import { z } from 'zod';

export const ThemePreferenceSchema = z.enum([
  'light',
  'dark',
  'contrast',
  'default',
]);
export type ThemePreference = z.infer<typeof ThemePreferenceSchema>;
export type Theme = Exclude<ThemePreference, 'default'>; // default is using system theme which will be one of the remaining 3.

export interface IThemeReader {
  getTheme(): Promise<Theme>;
  onThemeChange(callback: (theme: Theme) => void): void;
}
